import React, { useEffect, useState, useContext, useMemo } from 'react'
import { reactLocalStorage } from 'reactjs-localstorage'
import {
  PageContainer,
  Link,
  ProgramDetailLoader,
  OrgImage,
  Title,
  DataSteward,
  ButtonLabel,
  Map as MemberMap,
} from 'components'
import { Row, Col, Container } from 'react-bootstrap'
import { FaLinkedin, FaFacebook, FaTwitter } from 'react-icons/fa'
import styled from 'styled-components'
import nologo from 'images/snapp-icon.png'
import { useOrganization } from 'hooks/useOrganization'
import { UNKNOWN_VALUE, TWITTER_URL, DATE_FULL_YEAR } from 'utils/constants'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import { useProgram } from 'hooks/useProgram'
import { I18nContext } from 'i18n'
import { useQueryParams, navigate } from 'raviger'
import nspaIcon from 'images/nspa-icon.png'
import { device } from 'utils/device'
import theme from '../../themes/default'
import Map from '../../pages/MemberMapPage/Map'
import { useMemberMap } from 'hooks/useMemberMap'

const OrganizationDetail = () => {
  const [queryParams] = useQueryParams()
  const { name: queryName } = queryParams
  const [total, setTotal] = useState(0)
  const [totalVisible, setTotalVisible] = useState(0)
  const [annualGiven, setAnnualGiven] = useState(0) //numberOfScholarshipsAwarded
  const [totalAward, setTotalAward] = useState(0) //scholarshipMaximumAward
  const [mapOrganizations, setMapOrganizations] = useState([])
  const { data: dataMap, loading: loadingMap } = useMemberMap()
  const [selectedOrg, setSelectedOrg] = useState(null)

  const {
    dataPrograms,
    loadingPrograms,
    executePrograms,
    orgId,
    setOrgId,
  } = useProgram()

  const {
    dataDetailOrganization: dataDetail,
    loadingDetailOrganization: loadingDetail,
    errorDetailOrganization: errorDetail,
    setDetailName: setName,
    name: orgName,
  } = useOrganization()
  const [organization, setOrganization] = useState()
  const [isMine, setIsMine] = useState(false)
  const { translate } = useContext(I18nContext)
  const { organization: userOrg, fullName } = reactLocalStorage.getObject(
    'user'
  )

  useEffect(() => {
    const { name } = userOrg
    setName(queryName || name)
    const mine = !queryName || queryName === name
    setIsMine(mine)
    window.scrollTo({ top: 0, behavior: 'smooth' })

    return () => {
      setName(null)
    }
  }, [])

  useEffect(() => {
    executePrograms()
  }, [orgId])

  useEffect(() => {
    if (dataDetail) {
      const { detail } = dataDetail
      setOrganization(detail)
      setSelectedOrg(detail?.id)
      if (orgId !== detail?.id) {
        setOrgId(detail?.id)
      }
    }
  }, [dataDetail])

  useEffect(() => {
    if (dataDetail && dataPrograms) {
      const { programs } = dataPrograms
      let annual = 0,
        award = 0
      programs.forEach((p) => {
        annual += p.numberOfScholarshipsAwarded || 0
        award += p.scholarshipMaximumAward || 0
      })

      //Get the visible = "Visible" programs
      const visiblePrograms = programs.filter(
        ({ visibility }) => visibility === 'Visible'
      )

      setTotal(programs.length)
      setTotalVisible(visiblePrograms.length)
      setAnnualGiven(annual)
      setTotalAward(award)
    }
  }, [dataDetail, dataPrograms])

  useEffect(() => {
    if (dataMap) {
      const orgs = dataMap.data.filter(
        ({ latitude, longitude }) => latitude && longitude
      )
      setMapOrganizations(orgs)
    }
  }, [dataMap])

  const handleMarkerClick = (org) => {
    setSelectedOrg(org)
  }

  const handleInfoClose = () => {
    setSelectedOrg(null)
  }

  const renderPhone = (number, type) => (
    <Text>
      {number.replace(')', ') ')} <span>{translate(`member_${type}`)}</span>{' '}
    </Text>
  )

  /* Check if the user is the primary contact */
  const isPrimaryContact = useMemo(
    () =>
      fullName ===
      `${dataDetail?.detail?.firstName} ${dataDetail?.detail?.lastName}`,
    [fullName, dataDetail]
  )

  const UpdateHere = useMemo(
    () => ({ label = 'member_not_available' }) => (
      <>
        {isMine && isPrimaryContact ? (
          <a
            href="https://www.scholarshipproviders.org/members/edit.asp"
            target="_blank"
            className="font-weight-light"
          >
            Update Here
          </a>
        ) : (
          <span>{translate(label)}</span>
        )}
      </>
    ),
    [isMine, isPrimaryContact, translate]
  )

  const renderData = (details) => {
    const {
      website,
      addressLine1,
      addressLine2,
      city,
      country,
      postalCode,
      twitterHandle,
      facebookPage,
      linkedinPage,
      phoneNumber,
      firstName,
      lastName,
      faxNumber,
      nspaMemberId,
      name: orgName,
      stateCode,
      type,
      category,
      peerComparisonFactor,
      nspaMemberData,
      isNspaMember,
      latitude,
      longitude,
    } = details

    const { scholarshipMinimumAward, scholarshipMaximumAward } =
      peerComparisonFactor || {}

    const {
      orgMemberSince,
      location,
      yearFirstScholarship,
      totalNumberStudents,
      totalDollarAmount,
    } = nspaMemberData || {}

    return (
      <>
        <Col>
          <Row>
            <Col>
              <Row>
                <Col>
                  <h3 className="mb-1">{orgName}</h3>
                  {isNspaMember && orgMemberSince ? (
                    <Info>
                      <NspaIcon src={nspaIcon} alt="" />
                      <span>
                        {translate('member_since')}{' '}
                        {moment(orgMemberSince.split('T')[0]).format(
                          DATE_FULL_YEAR
                        )}
                      </span>
                    </Info>
                  ) : (
                    <Info>
                      <span>{translate('not_member_msg')}</span>
                    </Info>
                  )}
                  {website && (
                    <SocialLink>
                      <a href={website} target="_blank">
                        {website}
                      </a>
                    </SocialLink>
                  )}
                  {addressLine1 && (
                    <Section>
                      <Header>{translate('member_address')}</Header>
                      <Text>{addressLine1}</Text>
                      <Text>{addressLine2}</Text>
                      {city && (
                        <Text>{`${city}, ${location || stateCode || ''} ${
                          postalCode || ''
                        }`}</Text>
                      )}
                      <Text>{country}</Text>
                    </Section>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {(twitterHandle || facebookPage || linkedinPage) && (
                    <Section>
                      <Header>{translate('member_social')}</Header>

                      <SocialLink>
                        <span>
                          <FaTwitter />
                        </span>{' '}
                        {twitterHandle && twitterHandle !== UNKNOWN_VALUE ? (
                          <a
                            href={`${TWITTER_URL}/${twitterHandle.replace(
                              '@',
                              ''
                            )}`}
                            target="_blank"
                          >
                            {twitterHandle}
                          </a>
                        ) : (
                          <UpdateHere />
                        )}
                      </SocialLink>

                      <SocialLink>
                        <span>
                          <FaFacebook />
                        </span>{' '}
                        {facebookPage && facebookPage !== UNKNOWN_VALUE ? (
                          <a href={facebookPage} target="_blank">
                            {facebookPage.replace('https://www.', '')}
                          </a>
                        ) : (
                          <UpdateHere />
                        )}
                      </SocialLink>

                      <SocialLink>
                        <span>
                          <FaLinkedin />
                        </span>{' '}
                        {linkedinPage && linkedinPage !== UNKNOWN_VALUE ? (
                          <a href={linkedinPage} target="_blank">
                            {linkedinPage.replace('https://www.', '')}
                          </a>
                        ) : (
                          <UpdateHere />
                        )}
                      </SocialLink>
                    </Section>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col></Col>
          </Row>
          <Row>
            <Col>
              {nspaMemberId && (
                <Section>
                  <Info>
                    {translate('member_id')} <span>{nspaMemberId}</span>
                  </Info>
                </Section>
              )}
              <Section>
                <Info>
                  {translate('member_type')}{' '}
                  {type ? <span>{type}</span> : <UpdateHere />}
                </Info>
                <Info>
                  {translate('member_category')}{' '}
                  {category ? <span>{category}</span> : <UpdateHere />}
                </Info>
                <Info>
                  {translate('member_programs')}:{' '}
                  {isMine ? (
                    <span>{total || translate('member_not_available')}</span>
                  ) : (
                    <span>
                      {totalVisible || translate('member_not_available')}
                    </span>
                  )}
                </Info>
                <Info>
                  {translate('member_range')}
                  {!!scholarshipMinimumAward && (
                    <CurrencyFormat
                      value={scholarshipMinimumAward}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      suffix={scholarshipMaximumAward ? ' - ' : ''}
                    />
                  )}
                  {!!scholarshipMaximumAward && (
                    <CurrencyFormat
                      value={scholarshipMaximumAward}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                    />
                  )}
                  {!scholarshipMinimumAward && !scholarshipMaximumAward && (
                    <span>{translate('member_not_available')}</span>
                  )}
                </Info>
                <Info>
                  {translate('member_annual')}
                  {': '}
                  {totalNumberStudents > 0 ? (
                    <CurrencyFormat
                      value={totalNumberStudents}
                      displayType={'text'}
                      thousandSeparator={true}
                    />
                  ) : (
                    <UpdateHere />
                  )}
                </Info>

                <Info>
                  {translate('member_total')}
                  {': '}
                  {totalDollarAmount > 0 ? (
                    <CurrencyFormat
                      value={totalDollarAmount}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                    />
                  ) : (
                    <UpdateHere />
                  )}
                </Info>

                <Info>
                  {translate('member_first_scholarship')}{' '}
                  {yearFirstScholarship ? (
                    <span>{yearFirstScholarship}</span>
                  ) : (
                    <UpdateHere />
                  )}
                </Info>
              </Section>
            </Col>
          </Row>
          {isMine ? (
            <>
              <Row>
                <Col md={8}>
                  <ButtonLabel
                    color={theme.palette.secondary[0]}
                    onClick={() => navigate(`../programs`)}
                    permissions={['scholarships']}
                  >
                    {translate('organization_programs')}
                  </ButtonLabel>
                </Col>
              </Row>
              {isPrimaryContact && (
                <Row>
                  <Col>
                    <DataSteward>
                      <StyledLink
                        href={translate('member_contact_link', {
                          nspaMemberId,
                        })}
                        target="_blank"
                      >
                        {translate('member_edit_link')}
                      </StyledLink>
                    </DataSteward>
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <Row>
              <Col md={8}>
                <ButtonLabel
                  color={theme.palette.secondary[0]}
                  onClick={() => navigate(`./search/advanced/programs?org=${encodeURIComponent(orgName)}`)}
                  permissions={['scholarships']}
                >
                  {translate('organization_programs_search')}
                </ButtonLabel>
              </Col>
            </Row>
          )}
        </Col>
        <Col>
          {mapOrganizations && latitude && longitude ? (
            <div className="position-relative">
              <Map
                organizations={
                  isNspaMember
                    ? mapOrganizations
                    : mapOrganizations.filter((org) => org.id === orgId)
                }
                selectedOrg={selectedOrg}
                onMarkerClick={handleMarkerClick}
                onInfoClose={handleInfoClose}
                containerElement={<div style={{ height: '400px' }} />}
                mapElement={<div style={{ height: '400px' }} />}
                center={{ lat: latitude, lng: longitude }}
                zoom={10}
                showNonMembers={!isNspaMember}
              />
              <MapButton>
                <ButtonLabel
                  color={theme.palette.secondary[0]}
                  onClick={() =>
                    navigate(
                      `./member-map?orgId=${orgId}&orgName=${orgName}&lat=${latitude}&lng=${longitude}&isMember=${isNspaMember}`
                    )
                  }
                  permissions={['scholarships']}
                >
                  {translate('view_member_map')}
                </ButtonLabel>
              </MapButton>
            </div>
          ) : (
            <>
              {(city || location || stateCode || postalCode) && (
                <MemberMap
                  address={`${city || ''} ${location || stateCode || ''} ${
                    postalCode?.split('-')[0] || ''
                  }`}
                />
              )}
            </>
          )}
          {firstName && lastName && isNspaMember && (
            <>
              <Section>
                <Header>{translate('member_contact')}</Header>
                <Text underline>
                  <a
                    href={translate('member_contact_link', { nspaMemberId })}
                    target="_blank"
                  >
                    {`${firstName} ${lastName}`}
                  </a>
                </Text>
                <Text>{phoneNumber && renderPhone(phoneNumber, 'phone')} </Text>
                <Text>{faxNumber && renderPhone(faxNumber, 'fax')} </Text>
              </Section>
            </>
          )}
        </Col>
      </>
    )
  }

  return (
    <PageContainer showSources>
      {loadingPrograms || loadingDetail || loadingMap ? (
        <ProgramDetailLoader />
      ) : (
        <>
          <Row>
            <Col>
              <Title>{translate('breadcrumbs_organization_text')}</Title>
            </Col>
          </Row>
          <MemberContainer>
            {errorDetail && (
              <Container>
                <Row>
                  <Col md={{ offset: 3 }} className="pl-4">
                    <h3>404 - Not Found</h3>
                  </Col>
                </Row>
              </Container>
            )}
            <ImageContainer md="2">
              {organization?.id && (
                <OrgImage
                  logo={organization?.logoURL}
                  nologo={nologo}
                  orgId={organization?.id}
                />
              )}
              {/* <Image src={logo || nologo} alt="logo" fluid /> */}
            </ImageContainer>
            {dataDetail && organization && renderData(dataDetail?.detail)}
          </MemberContainer>
        </>
      )}
    </PageContainer>
  )
}

const ImageContainer = styled(Col)`
  text-align: center;
  margin-bottom: 2rem;
`

const MemberContainer = styled(Row)`
  margin-top: 3rem;
`

const Section = styled.div`
  margin: 1rem 0;
`

const Header = styled.div`
  font-weight: 600;
`

const Text = styled.div`
  font-weight: 300;
  ${({ underline }) => underline && `text-decoration: underline;`}

  > a {
    color: ${({ theme }) => theme.palette.grayscale[1]};
  }

  > span {
    color: ${({ theme }) => theme.palette.grayscale[3]};
  }
`

const Info = styled.div`
  font-weight: 600;
  > span {
    font-weight: 300;
  }
`

const SocialLink = styled.div`
  > a {
    color: ${({ theme }) => theme.palette.primary[3]};
  }

  > span {
    color: ${({ theme }) => theme.palette.grayscale[3]};
  }
`

const StyledLink = styled(Link)`
  font-weight: 400;
  font-size: 1rem;
  white-space: nowrap;
`

const MapButton = styled.div`
  position: absolute;
  width: 16rem;
  right: 0;
`

const NspaIcon = styled.img`
  width: 24px;
  margin-right: 0.5rem;

  @media ${device.laptopL} {
    position: unset;
  }
`

export default OrganizationDetail
